import { render, staticRenderFns } from "./BannerMtLink.vue?vue&type=template&id=b8908440&"
import script from "./BannerMtLink.vue?vue&type=script&lang=js&"
export * from "./BannerMtLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8908440')) {
      api.createRecord('b8908440', component.options)
    } else {
      api.reload('b8908440', component.options)
    }
    module.hot.accept("./BannerMtLink.vue?vue&type=template&id=b8908440&", function () {
      api.rerender('b8908440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/BannerMtLink/components/common/BannerMtLink.vue"
export default component.exports